function Footer() {
  return <footer>© 2026 Nadia Lee - Portfolio</footer>;
}

export default Footer;